import React, { useState, useEffect } from "react";
import BasketItem from "./components/BasketItem";
import Reg from "./components/Reg";
import { mainApi } from "../providers/api";
import { useTranslation } from "react-i18next";
const Basket = () => {
  const [list, setlist] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    const cart = localStorage.getItem("cart");
    setlist(cart ? JSON.parse(cart) : []);
    document.title = t("order.name");
  }, []);

  return (
    <div className="flex">
      <div className="flex-1 flex flex-col">
        <h3>{t("basket")}</h3>
        <div className="flex flex-wrap w-full mb-32">
          <div className="flex flex-wrap w-full md:w-2/3 p-2">
            {list && list.length > 0 ? (
              list.map((item, index) => (
                <BasketItem
                  key={index}
                  item={item}
                  setlist={setlist}
                  list={list}
                />
              ))
            ) : (
              <div>{t("list.empty")}</div>
            )}
          </div>
          <div className="flex flex-col w-full md:w-1/3 p-2">
            <Reg list={list} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Basket;
